var map = {
	"./Anemo.webp": 8,
	"./Cryo.webp": 7939,
	"./Dendro.webp": 7480,
	"./Electro.webp": 8634,
	"./Geo.webp": 5659,
	"./Hydro.webp": 6348,
	"./Pyro.webp": 7058,
	"./none.webp": 6016
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 148;